export var AnchorStatus;
(function (AnchorStatus) {
    AnchorStatus[AnchorStatus["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
    AnchorStatus[AnchorStatus["PENDING"] = 1] = "PENDING";
    AnchorStatus[AnchorStatus["PROCESSING"] = 2] = "PROCESSING";
    AnchorStatus[AnchorStatus["ANCHORED"] = 3] = "ANCHORED";
    AnchorStatus[AnchorStatus["FAILED"] = 4] = "FAILED";
    AnchorStatus[AnchorStatus["REPLACED"] = 5] = "REPLACED";
})(AnchorStatus || (AnchorStatus = {}));
export var AnchorServiceAuthMethods;
(function (AnchorServiceAuthMethods) {
    AnchorServiceAuthMethods["DID"] = "did";
})(AnchorServiceAuthMethods || (AnchorServiceAuthMethods = {}));
//# sourceMappingURL=anchor-service.js.map